var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"chat__list"},_vm._l((_vm.messages),function(message){return _c('ChatItem',{key:message.id,attrs:{"message":message}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }